import Report from './Report'
import Report2 from './Report2'
import C3Example from './C3Example'
import Performance from './Performance'
import PerformanceBK from './PerformanceBK'
import PerformanceBK1 from './PerformanceBK1'
import ChartC3Flow from './ChartC3Flow'
import ChartCloseJobC3 from './ChartCloseJobC3'
import ReportBooking from './ReportBooking.vue'
import BookingsourceLink from './BookingsourceLink.vue'
import BookingflowName from './BookingflowName.vue'
import BookingC3line from './BookingC3line.vue'
import BookingChartCarAndFlow from './BookingChartCarAndFlow.vue'
import ReportEmpMain from './ReportEmpMain.vue'
import ReportFRT from './ReportFRT.vue'
import DashBoardDepositPrice from './DashBoardDepositPrice.vue'
export default {
  Report,
  Report2,
  C3Example,
  Performance,
  PerformanceBK,
  PerformanceBK1,
  ChartC3Flow,
  ChartCloseJobC3,
  ReportBooking,
  BookingsourceLink,
  BookingflowName,
  BookingC3line,
  BookingChartCarAndFlow,
  ReportEmpMain,
  ReportFRT,
  DashBoardDepositPrice
}



// WEBPACK FOOTER //
// ./src/components/Dashbord/index.js